export const manifest = {
  screens: {
    scr_odohm2: { name: "Meet Snakker", route: "/", state: {"slideIndex":0}, position: {"x":160,"y":2200} },
    scr_b7yf4j: { name: "FAQ: What is a Snak?", route: "/", state: {"slideIndex":1}, position: {"x":12760,"y":220} },
    scr_blr9pa: { name: "What is a Snak?", route: "/", state: {"slideIndex":2}, position: {"x":1560,"y":2200} },
    scr_problem: { name: "The Problem", route: "/", state: {"slideIndex":3}, position: {"x":160,"y":220} },
    scr_episodic: { name: "Episodic Storytelling", route: "/", state: {"slideIndex":4}, position: {"x":2960,"y":220} },
    scr_anatomy: { name: "Anatomy of a Snak", route: "/", state: {"slideIndex":5}, position: {"x":4360,"y":220} },
    scr_satisfying: { name: "What makes it satisfying?", route: "/", state: {"slideIndex":6}, position: {"x":5760,"y":220} },
    scr_listens: { name: "The Story Listens Back", route: "/", state: {"slideIndex":7}, position: {"x":7160,"y":220} },
    scr_whysnakker: { name: "Why Snakker?", route: "/", state: {"slideIndex":8}, position: {"x":8560,"y":220} },
    scr_website: { name: "Snakkerfication of Websites", route: "/", state: {"slideIndex":9}, position: {"x":9960,"y":220} },
    scr_r91cdb: { name: "The Congress Journey", route: "/", state: {"slideIndex":10}, position: {"x":11360,"y":220} },
    scr_closeout: { name: "Get in Touch", route: "/", state: {"slideIndex":11}, position: {"x":160,"y":4180} },
  },
  sections: {
    sec_vo987w: { name: "Product Education", x: 0, y: 0, width: 14120, height: 1180 },
    sec_l1jwr6: { name: "Getting Started", x: 0, y: 1980, width: 2920, height: 1180 },
    sec_8dsdim: { name: "Closing & Contact", x: 0, y: 3960, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_vo987w", children: [
      { kind: "screen", id: "scr_problem" },
      { kind: "screen", id: "scr_episodic" },
      { kind: "screen", id: "scr_anatomy" },
      { kind: "screen", id: "scr_satisfying" },
      { kind: "screen", id: "scr_listens" },
      { kind: "screen", id: "scr_whysnakker" },
      { kind: "screen", id: "scr_website" },
      { kind: "screen", id: "scr_r91cdb" },
      { kind: "screen", id: "scr_b7yf4j" },
    ] },
    { kind: "section", id: "sec_l1jwr6", children: [
      { kind: "screen", id: "scr_odohm2" },
      { kind: "screen", id: "scr_blr9pa" },
    ] },
    { kind: "section", id: "sec_8dsdim", children: [
      { kind: "screen", id: "scr_closeout" },
    ] },
  ],
}
